const namespace = "blastDeposit";

export const DESCRIPTION = `${namespace}.description`;
export const DEPOSIT_BUTTON = `${namespace}.depositButton`;
